// extracted by mini-css-extract-plugin
export default {"width90":"ManuscriptDetailsModal_width90__+Km0T","customeModalStyle":"ManuscriptDetailsModal_customeModalStyle__9urpk"};